import { Gavel, Tag } from "lucide-react";
import { Input } from "@/components/ui/input";

// Pre-fill (before AI): Whatnot listing type + optional starting bid. Blank bid = the Price box is the starting bid.
export function PrefillWhatnot({ prefill, setPrefill }) {
  const auction = prefill.whatnot_format === "auction";
  const set = (k) => setPrefill((p) => ({ ...p, whatnot_format: k }));
  const chip = (k, label, Icon) => (
    <button type="button" onClick={() => set(k)} aria-pressed={prefill.whatnot_format === k} data-testid={`prefill-whatnot-${k}`}
      className={`inline-flex h-8 flex-1 items-center justify-center gap-1 rounded-md border text-[11px] font-semibold transition-colors ${prefill.whatnot_format === k ? "border-[#C99700] bg-[#C99700] text-white" : "border-slate-200 bg-white text-slate-600 hover:border-[#C99700]"}`}>
      <Icon className="h-3 w-3" /> {label}
    </button>
  );
  return (
    <div className="col-span-2" data-testid="prefill-whatnot">
      <p className="text-[10px] font-mono uppercase tracking-wider text-slate-500">Whatnot listing type</p>
      <div className="mt-1 flex gap-2">{chip("buy_it_now", "Buy It Now", Tag)}{chip("auction", "Auction", Gavel)}</div>
      {auction && (
        <div className="mt-2">
          <label htmlFor="prefill-auction-start" className="text-[10px] font-mono uppercase tracking-wider text-slate-500">Starting bid (USD)</label>
          <Input id="prefill-auction-start" value={prefill.auction_start} inputMode="decimal" placeholder="Blank = use Price" className="mt-1 h-8 font-mono text-xs"
            onChange={(e) => setPrefill((p) => ({ ...p, auction_start: e.target.value.replace(/[^0-9.]/g, "") }))} data-testid="prefill-auction-start-input" />
          <p className="mt-0.5 text-[9px] font-mono text-slate-400">blank uses the Price box; no price → your item cost</p>
        </div>
      )}
    </div>
  );
}

// Whatnot listing type (+ auction starting bid, prefilled from item cost); the extension picks these on Whatnot's form.
export default function WhatnotFormat({ draft, patch }) {
  const v = draft.whatnot_format === "auction" ? "auction" : "buy_it_now";
  const start = draft.auction_start ?? draft.item_cost ?? "";
  const opt = (key, label, Icon) => (
    <button type="button" onClick={() => patch({ whatnot_format: key })} data-testid={`whatnot-format-${key}`} aria-pressed={v === key}
      className={`inline-flex h-9 flex-1 items-center justify-center gap-1.5 rounded-full border text-xs font-semibold transition-colors ${v === key ? "border-[#C99700] bg-[#C99700] text-white" : "border-slate-300 bg-white text-slate-600 hover:border-[#C99700]"}`}>
      <Icon className="h-3.5 w-3.5" /> {label}
    </button>
  );
  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid="whatnot-format">
      <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">Whatnot listing type</p>
      <div className="mt-2 flex gap-2">{opt("buy_it_now", "Buy It Now", Tag)}{opt("auction", "Auction", Gavel)}</div>
      {v === "auction" && (
        <div className="mt-2">
          <label htmlFor="auction-start" className="text-[10px] font-mono uppercase tracking-wider text-slate-500">Starting bid (USD)</label>
          <Input id="auction-start" value={start} inputMode="decimal" placeholder="Your item cost" className="mt-1 h-9 font-mono"
            onChange={(e) => patch({ auction_start: e.target.value.replace(/[^0-9.]/g, "") })} data-testid="auction-start-input" />
          <p className="mt-0.5 text-[10px] text-slate-400" data-testid="auction-start-hint">
            {draft.auction_start == null && draft.item_cost ? "Prefilled with your item cost, so you never sell below what you paid." : "Starts at your item cost when you enter one."}
          </p>
        </div>
      )}
      <p className="mt-1.5 text-[10px] text-slate-400">The SnapList extension selects this on Whatnot, with quantity (at least 1), the most recent category, condition "Used and Fully Functioning" and shipping weight. You click Publish.</p>
    </div>
  );
}
